import type { ApprovedRepaymentInstalment } from '@solar/contracts';

import { formatNgn } from '../lib/format-currency';
import { formatBusinessDate } from '../lib/format-date';

import styles from './ApprovedRepaymentSchedule.module.css';

export function ApprovedRepaymentSchedule({
  rows,
  title = 'Approved repayment schedule',
}: {
  rows: readonly ApprovedRepaymentInstalment[];
  title?: string;
}): React.JSX.Element {
  return (
    <section className={styles.schedule} aria-label={title}>
      <h3>{title}</h3>
      <p>Agreed due dates and amounts. Payment status is shown separately.</p>
      <div className={styles.rows}>
        {rows.map((row) => (
          <div className={styles.row} key={row.sequenceNumber}>
            <span>Instalment {row.sequenceNumber}</span>
            <time dateTime={row.dueDate}>{formatBusinessDate(row.dueDate)}</time>
            <strong>{formatNgn(row.instalmentAmount)}</strong>
          </div>
        ))}
      </div>
    </section>
  );
}
